import { EventColor } from 'calendar-utils';
import { Component, OnInit } from '@angular/core';
import { GetItemsParams } from '../attorney/service/attorney.model';
import { HomepageService, PatientStatistics } from './services/homepage.service';
import { SharedService } from 'src/app/services/shared.service';
import { Page } from 'src/app/enums/enums';
import { Subject, takeUntil } from 'rxjs';
import { CalendarEvent } from 'angular-calendar';
import { startOfDay } from 'date-fns';
import { DialogueService } from 'src/app/services/dialogue.service';
import { MakeAppointmentDialogueComponent } from 'src/app/components/make-appointment-dialogue/make-appointment-dialogue.component';

const appointmentColors: { [key: string]: EventColor } = {
  'MD Appointment': { primary: '#FF5733', secondary: '#ffc9bd', secondaryText: '#FF5733' },
  'ROM Appointment': { primary: '#33FF57', secondary: '#dbffe2', secondaryText: '#33FF57' },
  'Cervical MRI': { primary: '#5733FF', secondary: '#e5e1fa', secondaryText: '#5733FF' },
  'Lumbar MRI': { primary: '#FF33A8', secondary: '#fcdcee', secondaryText: '#FF33A8' },
  'Other MRI 1': { primary: '#33FFF2', secondary: '#e1fcfb', secondaryText: '#33FFF2' },
  'Other MRI 2': { primary: '#FFB833', secondary: '#fceed4', secondaryText: '#FFB833' },
  'Other MRI 3': { primary: '#8D33FF', secondary: '#ede1fc', secondaryText: '#8D33FF' },
  'Neuro Appointment': { primary: '#337BFF', secondary: '#d9e5fa', secondaryText: '#337BFF' },
  'Upper EMG': { primary: '#FF3333', secondary: '#fce3e3', secondaryText: '#FF3333' },
  'Lower EMG': { primary: '#33FFB8', secondary: '#e1fcf3', secondaryText: '#33FFB8' },
  'Ortho Appointment': { primary: '#FF8333', secondary: '#fceade', secondaryText: '#FF8333' },
  Surgery: { primary: '#FF333F', secondary: '#fadee0', secondaryText: '#FF333F' }
};

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {
  public isLoading = false;
  public PaginationParams!: GetItemsParams;
  private Unsubscribe = new Subject<void>();
  public CalenderEventes!: CalendarEvent[];
  public AppointmentsStatus: PatientStatistics = {
    activePatients: {
      dischargeToday: 0,
      total: 0
    },
    internalMedicine: { complete: 0, pending: 0, total: 0 },
    neurologist: { complete: 0, pending: 0, total: 0 },
    orthopedist: { complete: 0, pending: 0, total: 0 }
  };

  constructor(private homePageService: HomepageService, public sharedService: SharedService, private dialogue: DialogueService) {
    this.PaginationParams = {
      clinicId: this.sharedService.CurrentClinic.value || 0,
      fromDate: '',
      toDate: '',
      searchValue: '',
      skip: 0,
      sortColumn: 'attorneyName',
      take: Number(this.sharedService.getData('records')) || Page.Size,
      sortOrder: 'asc'
    };
  }

  ngOnInit(): void {
    this.PaginationParams.fromDate = this.GetCurrentMonthStartAndEndDates().startOfMonth;
    this.PaginationParams.toDate = this.GetCurrentMonthStartAndEndDates().endOfMonth;
    this.sharedService.CurrentClinic.pipe(takeUntil(this.Unsubscribe)).subscribe((val) => {
      this.PaginationParams.clinicId = Number(val);
      this.GetAppointments(this.PaginationParams);
      this.GetAppointmentStatus(this.PaginationParams);
    });
  }

  GetAppointments(params: GetItemsParams) {
    const response = this.homePageService.GetAppointmentsList(params);
    response.subscribe({
      next: (appointmentResults) => {
        const transformedData = appointmentResults
          .map((result) => {
            return result.appointments.map((appointment) => ({
              start: startOfDay(new Date(result.date)),
              title: `${appointment.lastName} ${appointment.firstName} - ${appointment.appointmentType}`,
              color: { ...appointmentColors[appointment.appointmentType] },
              patientId: appointment.patientId
            }));
          })
          .flat();
        this.CalenderEventes = [...transformedData];
      },
      error: () => {},
      complete: () => {}
    });
  }
  GetAppointmentStatus(params: GetItemsParams) {
    const response = this.homePageService.GetAppointmentsStatus(params);
    response.subscribe({
      next: (appointmentResults: PatientStatistics) => {
        this.AppointmentsStatus = { ...appointmentResults };
      },
      error: () => {},
      complete: () => {}
    });
  }

  FormatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  GetSelectedMonth(eve: Date) {
    this.PaginationParams.fromDate = this.GetCurrentMonthStartAndEndDates(eve).startOfMonth;
    this.PaginationParams.toDate = this.GetCurrentMonthStartAndEndDates(eve).endOfMonth;
    this.GetAppointments(this.PaginationParams);
  }

  GetCurrentMonthStartAndEndDates(date?: Date) {
    const now = date || new Date();
    const startOfMonth = this.FormatDate(new Date(now.getFullYear(), now.getMonth(), 1));
    const endOfMonth = this.FormatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0));

    return {
      startOfMonth,
      endOfMonth
    };
  }

  CheckAppt(val: CalendarEvent) {
    this.dialogue.Open(MakeAppointmentDialogueComponent, { size: 'xl' }, val);
  }
}
